import request from './request';

// 获取用户信息
export function getUserInfo() {
    return request({
      url: '/mail/user/info',
      method: 'get',
      needAuth: true
    });
  }

// 编辑用户信息
export function updateUser(data) {
  return request({
    url: '/mail/user/update',
    method: 'put',
    data,
    needAuth: true
  });
}

// 设置密码
export function setUserPassword(data) {
  return request({
    url: '/mail/user/set_password',
    method: 'put',
    data,
    needAuth: true
  });
}

// 获取全部个人地址
export function getAddressList() {
  return request({
    url: '/mail/address',
    method: 'get',
    needAuth: true
  });
}

// 添加地址
export function addAddress(data) {
  return request({
    url: '/mail/address',
    method: 'post',
    data,
    needAuth: true
  });
}

// 编辑地址
export function updateAddress(id, data) {
  return request({
    url: `/mail/address/${id}`,
    method: 'put',
    data,
    needAuth: true
  });
}

// 删除地址
export function deleteAddress(id) {
  return request({
    url: `/mail/address/${id}`,
    method: 'delete',
    needAuth: true
  });
}

// 获取购物车列表
export function getCartList(params) {
  return request({
    url: '/mail/products/cart',
    method: 'get',
    params,
    needAuth: true
  });
}

// 添加购物车
export function addToCart(data) {
  return request({
    url: '/mail/products/cart',
    method: 'post',
    data,
    needAuth: true
  });
}

// 删除购物车商品
export function deleteCartItem(id) {
  return request({
    url: `/mail/products/cart/${id}`,
    method: 'delete',
    needAuth: true
  });
}

// 修改购物车商品（数量、备注等）
export function updateCartItemQuantity(item_id, quantity, remark = null) {
  const data = { item_id, quantity };
  if (remark !== undefined) {
    data.remark = remark;
  }
  return request({
    url: `/mail/products/cart/${item_id}`,
    method: 'put',
    data,
    needAuth: true
  });
}


// 创建订单
export function createOrder(data) {
  return request({
    url: '/mail/order',
    method: 'post',
    data,
    needAuth: true
  });
}

// 创建购物车订单
export function createCartOrder(data) {
  return request({
    url: '/mail/order/cart',
    method: 'post',
    data,
    needAuth: true
  });
}

// 获取订单状态
export function getOrderStatus(order_id) {
  return request({
    url: `/mail/order/status/${order_id}`,
    method: 'get',
    needAuth: true
  });
}

// 获取订单列表
export function getOrderList(params) {
  return request({
    url: '/mail/order',
    method: 'get',
    params,
    needAuth: true
  });
}

// 获取订单详情
export function getOrderDetail(id) {
  return request({
    url: `/mail/order/${id}`,
    method: 'get',
    needAuth: true
  });
}

// 删除订单
export function deleteOrder(id) {
  return request({
    url: `/mail/order/${id}`,
    method: 'delete',
    needAuth: true
  });
}

// 获取用户店铺列表
export function getStoreList() {
  return request({
    url: '/mail/store/list',
    method: 'get',
    needAuth: true
  });
}

// 获取默认店铺
export function getDefaultStore() {
  return request({
    url: '/mail/store/default',
    method: 'get',
    needAuth: true
  });
}

// 重新支付订单
export function renewPayment(data) {
  return request({
    url: '/mail/order/payment/renew',
    method: 'post',
    data,
    needAuth: true
  });
}

// 用户注销申请
export function deleteUserRequest(data) {
  return request({
    url: '/mail/user/delete_request',
    method: 'post',
    data,
    needAuth: true
  });
}

// 获取用户注销最新申请
export function getDeleteLatestRequest() {
  return request({
    url: '/mail/user/delete_lastest_request',
    method: 'get',
    needAuth: true
  });
}

// 用户注销（保留原接口以防需要）
export function deleteUser() {
  return request({
    url: '/mail/user/delete_user',
    method: 'delete',
    needAuth: true
  });
}

// 获取订单分享详情
export function getOrderShareDetail(params) {
  return request({
    url: '/mail/order/share/detail',
    method: 'get',
    params,
    needAuth: false
  });
}

// 订单分享支付（仅支持微信浏览器）
export function orderSharePayment(wechatAccessToken, data) {
  return request({
    url: '/mail/order/share/payment',
    method: 'post',
    params: {
      wechat_access_token: wechatAccessToken
    },
    data,
    needAuth: false
  });
}

// 微信认证（微信网页支付：安全获取openid）
export function wechatAuth(params) {
  return request({
    url: '/mail/wechat/auth',
    method: 'get',
    params,
    needAuth: false
  });
}

